/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { showError } from '@utils';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'constants/queryKeys';
import { reservationServices } from '@services';
import { useAssignees } from 'hooks/common';
import {
  normalizeReservationData,
  normalizeReservationHistory,
  normalizeReservationsEnums,
} from './utils';

export const useReservationOperations = () => {
  const router = useRouter();
  const { assignees, isFetching: isAssigneesFetching } = useAssignees();
  const reservationId = router.query?.reservationId;
  const { back } = router;

  const reservationResponse = useQuery(
    [QUERY_KEYS.GET_RESERVATION_KEY, reservationId],
    () => reservationServices.getReservationById(reservationId),
    {
      enabled: !!reservationId,
    }
  );

  const reservationCommentsResponse = useQuery(
    [QUERY_KEYS.GET_RESERVATION_COMMENTS_KEY, reservationId],
    () => reservationServices.getReservationComments(reservationId),
    {
      enabled: !!reservationId,
    }
  );

  const reservationsEnumsResponse = useQuery(
    QUERY_KEYS.GET_RESERVATIONS_ENUMS_KEY,
    () => reservationServices.getReservationsEnums()
  );

  const reservationsEnums = normalizeReservationsEnums(
    reservationsEnumsResponse?.data?.data || {}
  );

  const reservationHistoryResponse = useQuery(
    [QUERY_KEYS.GET_RESERVATION_HISTORY_KEY, reservationId],
    () => reservationServices.getReservationsHistoryById(reservationId),
    {
      enabled: !!reservationId,
    }
  );

  const history = normalizeReservationHistory(
    reservationHistoryResponse?.data?.data || []
  );

  const reservation = normalizeReservationData(
    reservationResponse?.data?.data || [],
    reservationCommentsResponse?.data?.data || [],
    assignees
  );

  const mentionedUsers = assignees
    ?.filter((user) => user?.isActive === true)
    ?.map?.((user) => {
      return { id: user?.value, display: user?.text };
    });

  const refetch = async () => {
    await reservationResponse.refetch();
    await reservationCommentsResponse.refetch();
  };

  const loading =
    reservationResponse.isFetching ||
    reservationHistoryResponse.isFetching ||
    isAssigneesFetching ||
    reservationCommentsResponse.isFetching;

  useEffect(() => {
    if (reservationResponse.isError) {
      showError(reservationResponse.error);
    }
  }, [reservationResponse.isError]);

  useEffect(() => {
    if (reservationCommentsResponse.isError) {
      showError(reservationCommentsResponse.error);
    }
  }, [reservationCommentsResponse.isError]);

  useEffect(() => {
    if (reservationHistoryResponse.isError) {
      showError(reservationHistoryResponse.error);
    }
  }, [reservationHistoryResponse.isError]);

  useEffect(() => {
    if (reservationsEnumsResponse.isError) {
      showError(reservationsEnumsResponse.error);
    }
  }, [reservationResponse.isError]);

  return {
    loading,
    reservationId,
    reservation,
    getReservation: refetch,
    goBack: back,
    history,
    getHistory: reservationHistoryResponse.refetch,
    agents: assignees,
    reservationsTypes: reservationsEnums?.types || [],
    mentionedUsers,
  };
};
